import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { colors } from '@nw/shared/config';

import { SVGComponentProps } from '../type';

interface EnrollmentPaymentOptionRadioIconProps extends SVGComponentProps {
  selected: boolean;
}

const EnrollmentPaymentOptionRadioIcon: FC<
  EnrollmentPaymentOptionRadioIconProps
> = ({ width = 16, height = 16, selected }) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {selected ? (
        <>
          <circle cx="8" cy="8" r="8" fill={colors['light-red-900']} />
          <circle cx="8" cy="8" r="3" fill={colors['base-white']} />
        </>
      ) : (
        <circle
          cx="8"
          cy="8"
          r="7.5"
          fill={colors['base-white']}
          stroke={colors['light-blue-gray-200']}
        />
      )}
    </svg>
  </SVGUniqueID>
);

export { EnrollmentPaymentOptionRadioIcon };
